import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
@Component({
  selector: 'app-dashboardui',
  templateUrl: './dashboardui.component.html',
  styleUrls: ['./dashboardui.component.scss'],
})
export class DashboarduiComponent implements OnInit {
  now = moment();
  ngOnInit(): void {
    console.log(localStorage.getItem('email'));
    console.log(this.now.hour());
  }
  test() {}
}
